"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var CSV = __importStar(require("csv-stringify/browser/esm/sync"));
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var MenuItem_1 = __importDefault(require("shared/components/DropdownMenu/MenuItem"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var formatters_1 = require("utils/formatters");
var logging_1 = require("utils/logging");
var single_1 = require("utils/selectors/single");
var DownloadServices = function (_a) {
    var _b;
    var serviceStats = _a.serviceStats, removed = _a.removed, onClose = _a.onClose;
    var _c = __read((0, react_1.useState)(false), 2), downloading = _c[0], setDownloading = _c[1];
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var annualSpend = 'spend_last_12_months';
    var billingOwner = 'billing_owner';
    var billingCycleInMonths = 'billing_cycle_in_months';
    var nextPayment = 'next_payment';
    var headers = ['tool', annualSpend, 'teams', billingOwner, 'status', 'rating', 'renewalDateNext', 'renewalFrequency', nextPayment,
        billingCycleInMonths];
    var CUSTOM_FIELD_MAPPER = (_b = {
            tool: function (_a) {
                var service = _a.service;
                return (service === null || service === void 0 ? void 0 : service.niceName) || (service === null || service === void 0 ? void 0 : service.name);
            }
        },
        _b[annualSpend] = function (sS) { return sS.calculatedAnnualSpend && (0, fieldProcessors_1.formatNumber)(Math.round(sS.calculatedAnnualSpend), company === null || company === void 0 ? void 0 : company.baseCurrency); },
        _b.teams = function (sS) { var _a; return (_a = sS.companyTeams) === null || _a === void 0 ? void 0 : _a.map(function (team) { return team.name; }).join(); },
        _b[billingOwner] = function (_a) {
            var owner = _a.owner;
            return (0, end2end_1.getDisplayName)(owner);
        },
        _b.status = function (sS) { return sS.activeStatus; },
        _b.rating = function (_a) {
            var avgRating = _a.avgRating;
            return avgRating ? (Math.round(avgRating * 10) / 10).toFixed(1) : 'N/A';
        },
        _b[billingCycleInMonths] = function (_a) {
            var _b;
            var billingData = _a.billingData;
            return (_b = billingData === null || billingData === void 0 ? void 0 : billingData.cycle) === null || _b === void 0 ? void 0 : _b.months;
        },
        _b[nextPayment] = function (_a) {
            var billingData = _a.billingData;
            return (billingData === null || billingData === void 0 ? void 0 : billingData.nextPayment) && (0, date_fns_1.format)(billingData.nextPayment.toDate(), 'yyyy-MM-dd');
        },
        _b);
    var handleDownloadServiceStats = function () { return __awaiter(void 0, void 0, void 0, function () {
        var services, data;
        return __generator(this, function (_a) {
            setDownloading(true);
            if (!serviceStats.length) {
                setDownloading(false);
                return [2 /*return*/];
            }
            services = serviceStats.map((0, fieldProcessors_1.makeCsvRowGenerator)(headers, CUSTOM_FIELD_MAPPER, true));
            data = CSV.stringify(__spreadArray([headers.map(formatters_1.camelToSnake)], __read(services), false));
            try {
                (0, fieldProcessors_1.saveAsCSV)(data, "Hudled - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s software stack").concat(removed ? ' [REMOVED]' : '', ".csv"));
            }
            catch (e) {
                (0, logging_1.logError)(e);
            }
            setDownloading(false);
            onClose();
            return [2 /*return*/];
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ onClick: handleDownloadServiceStats, autoFocus: true }, { children: (0, jsx_runtime_1.jsx)(ListItemText_1.default, { children: !downloading ? 'My stack' : 'Exporting my stack...' }) })));
};
exports.default = DownloadServices;
